// eBook API service
const API_BASE_URL = process.env.REACT_APP_API_BASE || 'https://your-function-app.azurewebsites.net/api';

const eBookService = {
  // Get all eBooks with optional filtering - alias method name
  async getAllEBooks(filters = {}) {
    return this.getEBooks(filters);
  },

  // Get all eBooks with optional filtering
  async getEBooks(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.isActive !== undefined) {
        params.append('isActive', filters.isActive);
      }
      if (filters.tag) {
        params.append('tag', filters.tag);
      }
      if (filters.category) {
        params.append('category', filters.category);
      }
      if (filters.userId) {
        params.append('userId', filters.userId);
      }

      const response = await fetch(`${API_BASE_URL}/ebook/get?${params}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      // Handle new Firebase response format
      return result.data ? result.data : (Array.isArray(result) ? result : []);
    } catch (error) {
      console.error('Error fetching eBooks:', error);
      throw error;
    }
  },

  // Get single eBook by ID
  async getEBook(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/ebook/get?id=${id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      // Handle new Firebase response format
      return result.data ? result.data[0] : result;
    } catch (error) {
      console.error('Error fetching eBook:', error);
      throw error;
    }
  },

  // Create new eBook
  async createEBook(eBookData) {
    try {
      const response = await fetch(`${API_BASE_URL}/ebook/post`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eBookData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data || result;
    } catch (error) {
      console.error('Error creating eBook:', error);
      throw error;
    }
  },

  // Update existing eBook
  async updateEBook(id, eBookData) {
    try {
      const response = await fetch(`${API_BASE_URL}/ebook/put?id=${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eBookData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data || result;
    } catch (error) {
      console.error('Error updating eBook:', error);
      throw error;
    }
  },

  // Delete eBook
  async deleteEBook(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/ebook/delete?id=${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data || result;
    } catch (error) {
      console.error('Error deleting eBook:', error);
      throw error;
    }
  },

  // Translate eBook content
  async translateEBook(id, targetLanguage) {
    try {
      const response = await fetch(`${API_BASE_URL}/ebook/translate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          targetLanguage: targetLanguage
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data || result;
    } catch (error) {
      console.error('Error translating eBook:', error);
      throw error;
    }
  }
};

export default eBookService;
